// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type xHotspotProductType = {
    isErpsLoading: boolean;
    productsByErps: any;
    productsInfo: { [erp: string]: ProductInfo };
};

const initialState: xHotspotProductType = {
    isErpsLoading: false,
    productsByErps: [],
    productsInfo: {},
};

const xHotspotProduct = createTypedReducerWithImmer(initialState, {
    "HotspotProduct/AddProductsInfo": (
        draft: Draft<xHotspotProductType>,
        actions: { productsInfo: any; },
    ) => {
        draft.productsInfo = { ...draft.productsInfo, ...actions.productsInfo };
    },

    "HotspotProduct/erpsIsLoading": (draft: Draft<xHotspotProductType>) => {
        draft.isErpsLoading = true;
    },
    "HotspotProduct/resetHotspotInfo": (draft: Draft<xHotspotProductType>) => {
        draft.productsByErps = [];
        draft.productsInfo = {};
    },
    "HotspotProduct/ProductsByErps": (draft: Draft<xHotspotProductType>, actions: { productsByErps: any }) => {
        draft.isErpsLoading = false;
        draft.productsByErps = [...draft.productsByErps, ...actions.productsByErps];
    },
    "HotspotProduct/UpdatePageProductQty": (draft: Draft<xHotspotProductType>, actions: { qtyOrdered: number; productErp: string }) => {
        draft.productsInfo[actions.productErp].qtyOrdered = actions.qtyOrdered;
    },
    "HotspotProduct/UpdatePageProductUom": (draft: Draft<xHotspotProductType>, actions: { uom: string; productErp: string }) => {
        draft.productsInfo[actions.productErp].unitOfMeasure = actions.uom;
    },
});

(reducers as any).xHotspotProduct = xHotspotProduct;

export type xHotspotProductState = {
    xHotspotProduct: xHotspotProductType;
} & ApplicationState;

type xHotspotProductReducers = {
    xHotspotProduct: typeof xHotspotProduct;
};

export type hotspotProductActions = Parameters<xHotspotProductReducers[keyof xHotspotProductReducers]>[1] | AnyAction;
